import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";
import ViewLeave from "./view";
import EditLeave from "./edit";
import HyvidAwards from "./index";
import { MODULE_AWARDS } from "variables/modules";
import { displayIcon } from "variables/icons";

const hyvidAwardRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Hyvid Awards",
		basePath: "hyvid-awards",
		mainComponent: <HyvidAwards />,
	    layout: "/console",	   
	    icon: displayIcon('Medal', 'icon-item'),
	    subTitle:"Hyvid Awards",
	    viewComponent: <ViewLeave />,
	    createComponent: <EditLeave />,
	    editComponent: <EditLeave />,
		level:4,
		moduleId: MODULE_AWARDS,
	})
]

export default hyvidAwardRoutes;